import React from 'react';
import {ProgramFilter} from './ProgramFilter';
import {IWithDisabled} from 'models';

export function ProgramFilterSingle({disabled}: IWithDisabled) {
  return <ProgramFilter selectionType="single" disabled={disabled} />;
}
